export default function reducer(state, action) {
  switch (action.type) {
    case "HANDLE_SHOW":
      return {
        ...state,
        data: action.payload,
        show: !state.show,
        edit: false,
      };
    case "HANDLE_UPLOAD":
      return {
        ...state,
        allValidData: [],
        allInvalidData: [],
        origData: [],
        data: [],
      };
    case "HANDLE_UPLOAD_VALID_DATA":
      return {
        ...state,
        allValidData: [],
        allInvalidData: [],
        origData: [],
        data: action.payload,
      };
    case "SET_INVALIDDATA":
      const inValids = state.data.map((d) => {
        if (!d.condition.toLowerCase().includes("success")) {
          return d;
        }
      });
      return {
        ...state,
        allInvalidData: inValids,
      };
    case "SET_VALIDDATA":
      const valids = state.data.map((d) => {
        if (d.condition.toLowerCase().includes("success")) {
          return d;
        }
      });

      return {
        ...state,
        allValidData: valids,
      };
    case "SET_DATA":
      return {
        ...state,
        data: action.payload,
        origData: action.payload,
      };

    case "SET_TAB_DATA":
      return {
        ...state,
        data: action.payload,
      };
    case "SET_ORIG_DATA":
      return {
        ...state,
        origData: action.payload,
      };

    case "GET_DATA":
      return state;

    case "SET_HASINVALID":
      return {
        ...state,
        hasInvalid: action.payload,
      };
    case "HANDLE_DELETE":
      return {
        ...state,
        origData: action.payload,
        data: action.payload,
      };
    case "UPDATE_ROW":
      return {
        ...state,
        data: action.payload,
      };
    case "SET_ACTIVETAB":
      return {
        ...state,
        activeTab: action.payload,
      };
    case "HANDLE_RESET":
      return {
        ...state,
        allValidData: [],
        allInvalidData: [],
        origData: [],
        data: [],
        activeTab: 0,
      };
    default:
      return state;
  }
}
